export enum ConditionKind {
    ALWAYS = 0,
    NOTNULL = 1,
    ISNULLL = 2,
    EQUALS = 3,
    DIFF = 4,
    LIKE = 5,
    IN = 6,
    NEQUALS = 7,
    ISEMPTY = 8,
    ISTRUE = 9,
    ISNOTGROUP = 10,
    ISGROUP = 11,
    AFTER = 12,
    BEFORE = 13,
    NOTIN = 14,
    ISCURRENTUSER = 15,
    ISNOTCURRENTUSER = 16,
    HASUSER = 17,
    ISANONYMOUS = 18,
    LTEQUALS = 19,
    GTEQUALS = 20,
    DEFAULT = 21,
    HASERROR = 22,
    ISBETWEEN = 23,
    GT = 24,
    LT = 25,
    NOTERROR = 26,
    ISUUID = 27,
    ISNUMBER = 28,
    ISNOTNUMBER = 29,
    ISNOTEMPTY = 30,
    ISFALSE = 31,
    CONTAINS = 32,
    REGEX_TEST = 33,
    AFTEROREQUALS = 34,
    BEFOREOREQUALS = 35
}
